export default __webpack_public_path__ + "img/smart-infrastructure.773b7fb6.png";